import type { UserProfile } from '../../types/extranet-api.types';

export const PROFILE_LABELS: Record<UserProfile, string> = {
  admin: 'Administrateur',
  viewer: 'Lecture seule',
  buyer: 'Acheteur',
  gm: 'GM',
  gef: 'GEF',
  dpx: 'DPX',
  regional_lead: 'Resp. régional',
};

export const PROFILE_COLORS: Record<UserProfile, { bg: string; text: string }> = {
  admin: { bg: 'bg-zinc-900', text: 'text-white' },
  viewer: { bg: 'bg-zinc-100', text: 'text-zinc-500' },
  buyer: { bg: 'bg-blue-50', text: 'text-blue-700' },
  gm: { bg: 'bg-emerald-50', text: 'text-emerald-700' },
  gef: { bg: 'bg-amber-50', text: 'text-amber-800' },
  dpx: { bg: 'bg-zinc-100', text: 'text-zinc-700' },
  regional_lead: { bg: 'bg-zinc-100', text: 'text-zinc-700' },
};

export const ALL_PROFILES: UserProfile[] = ['admin', 'buyer', 'gm', 'gef', 'dpx', 'regional_lead'];

export const ProfilesBadgeList = ({ profiles }: { profiles: UserProfile[] }) => (
  <span className="inline-flex items-center gap-1 flex-wrap">
    {profiles.map(p => {
      const tokens = PROFILE_COLORS[p];
      return (
        <span
          key={p}
          className={`inline-flex items-center rounded-md text-[10px] font-medium px-1.5 py-0.5 ${tokens.bg} ${tokens.text}`}
        >
          {PROFILE_LABELS[p]}
        </span>
      );
    })}
  </span>
);
